export default __webpack_public_path__ + "static/objStyle-ba40f835cfb9ed92c763ed6d309b8a80.png";